__turbopack_context__.v({
  "chip": "T9dRAq_chip",
  "chip--interactive": "T9dRAq_chip--interactive",
  "chip--is-rounded": "T9dRAq_chip--is-rounded",
  "chip--not-clickable": "T9dRAq_chip--not-clickable",
  "chip--small": "T9dRAq_chip--small",
  "chip--theme-active": "T9dRAq_chip--theme-active",
  "chip--theme-emphasis": "T9dRAq_chip--theme-emphasis",
  "chip--theme-light": "T9dRAq_chip--theme-light",
  "chip__icon-container": "T9dRAq_chip__icon-container",
});
